import { TeamDataObject } from "../DataStorage/TeamDataObject";
import { BuilderChangeSetStatus } from "./BuilderChangeSetStatus";

export class BuilderChangeSet extends TeamDataObject {
    name: string;
    status: BuilderChangeSetStatus = BuilderChangeSetStatus.OPEN;
    closedOnDate?: Date;
    countUnmerged: number = 0;
    count: number = 0;

    constructor(name: string) {
        super();
        this.name = name;
    }
}
